import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import App from './App.jsx';
import ErrorBoundary, { CHUNK_RELOAD_FLAG } from './components/ErrorBoundary.jsx';
import { ThemeProvider } from './context/ThemeContext.jsx';
import { AuthProvider } from './context/AuthContext.jsx';
import { CartProvider } from './context/CartContext.jsx';
import { RetailCartProvider } from './context/RetailCartContext.jsx';
import { FavoritesProvider } from './context/FavoritesContext.jsx';
import './index.css';

// Si a los pocos segundos seguimos vivos (no volvimos a crashear), liberamos la
// guarda para que un futuro despliegue pueda volver a auto-recargar. Si la
// limpiáramos de inmediato, un chunk realmente roto (no solo desactualizado)
// dispararía un reload infinito: cada recarga borraría la guarda que la recarga
// anterior acababa de dejar.
setTimeout(() => sessionStorage.removeItem(CHUNK_RELOAD_FLAG), 4000);

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    {/* v7_startTransition desactivado: choca con AnimatePresence y crashea el scheduler al cambiar de categoría */}
    <BrowserRouter future={{ v7_relativeSplatPath: true }}>
      <ErrorBoundary>
        <ThemeProvider>
          <AuthProvider>
            <FavoritesProvider>
              <CartProvider>
                <RetailCartProvider>
                  <App />
                  <Toaster
                    position="bottom-right"
                    toastOptions={{
                      style: {
                        background: '#1C1C1C',
                        color: '#F2F4F5',
                        borderRadius: '12px',
                        fontSize: '14px',
                      },
                    }}
                  />
                </RetailCartProvider>
              </CartProvider>
            </FavoritesProvider>
          </AuthProvider>
        </ThemeProvider>
      </ErrorBoundary>
    </BrowserRouter>
  </React.StrictMode>
);
